import type { FaireProductEntity } from "../../entity_types/product";

export const p_ey8twzw52f: FaireProductEntity = {
  token: "p_ey8twzw52f",
  type: "product",
  name: "Nutrex Mass Infusion Advanced Mass Gainer",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8ab21b1264654e6843db0dbb749c96106e3280f8097019fdb6d712664b13661b.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4ae9942b428e5dd7275cf9edd7f0ddff9b9e3a56b14874c3f193244b5e1f667a.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
